<template>
	<div>
		<div class="content">
<!--      <el-carousel trigger="click" v-if="swiper.length > 0"  style="height: 500px;" :autoplay="false" motion-blur indicator-position="none">
        <el-carousel-item v-for="(item,index) in swiper" style="height: 500px;" :key="index">
          <div class="jumbotron" :style="{background:`url(${item.images})`}">
          </div>
        </el-carousel-item>
      </el-carousel> -->
      <div class="jumbotron">
        <div class="container-afwy">
          <div class="masthead">
            <div class="home-title">{{$namePc}}</div>
            <div class="home-title">专业卡券回收平台</div>
            <p class="home-des">各大电商礼品卡回收 旅游卡 游戏卡 商超卡 话费 充值卡中石化加油卡回收 兑换 线下超市购物卡回购 提现 换购 变现</p>
            <router-link class="btn btn-green btn-lg btn-sellform" :to="{path:'/shop'}">立即回收</router-link>
          </div>
          <img src="../../static/images/home/new/erp-system-img.png" class="conwds-img" />

        </div>
      </div>
			<div class="panel panel-stepflow">
				<div class="container">
					<div  style="margin-top: -120px;">
						<notic :noticle="noticle" :noticleList="noticleList"></notic>
					</div>
					<div class="dds-stepflows">
						<ul class="stepflow-group clearfix">
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-sign icon-weibiaoti5"></i>
								</div>
								<div class="title">注册账号</div>
								<div class="num">01</div>
							</li>
							<li >
								<div class="flow">登录账号</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-realname icon-shimingrenzheng"></i>
								</div>
								<div class="title">实名认证</div>
								<div class="num">02</div>
							</li>
							<li >
								<div class="flow">绑定提现账号</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-input icon-tijiao"></i>
								</div>
								<div class="title">提交卡密</div>
								<div class="num">03</div>
							</li>
							<li >
								<div class="flow">等待平台验卡</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-verify icon-yanzheng"></i>
								</div>
								<div class="title">验卡成功</div>
								<div class="num">04</div>
							</li>
							<li >
								<div class="flow">相应资金到账</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-cash icon-tixian1"></i>
								</div>
								<div class="title">账户提现</div>
								<div class="num">05</div>
							</li>
							<li >
								<div class="flow">支付宝或微信</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-completed icon-wancheng"></i>
								</div>
								<div class="title">交易成功</div>
								<div class="num">06</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<hotCommon></hotCommon>
			<div class="panel panel-what" >
				<div class="container" >
					<div class="panel-heading">
						<h3 class="panel-title">{{$namePc}}有什么优势？</h3>
						<div class="panel-subtitle">
							<p>
								您的每一个问题都有客服一一回答
							</p>
						</div>
					</div>
					<div class="panel-body">
						<ul class="what-group clearfix">
							<li>
								<div class="what-group-inner">
									<i class="iconimg iconimg-1"></i>
									<h5>便利快捷</h5>
									<p>{{$namePc}}全程急速销卡，资金快速回笼安全无忧，系统安全稳定，7X24小时客服维护支持，资金安全保证，全程资金安全监管保证</p>
								</div>
							</li>
							<li>
								<div class="what-group-inner">
									<i class="iconimg iconimg-2"></i>
									<h5>资金回流</h5>
									<p>{{$namePc}}最大限度让利，打造双方互利互赢平台，收益急速代发，资金一秒到账安全稳</p>
								</div>
							</li>
							<li class="last">
								<div class="what-group-inner">
									<i class="iconimg iconimg-3"></i>
									<h5>交易多样</h5>
									<p>{{$namePc}}批量后台提交，快速销卡通道无缝对接，多卡通道选择，快速安全稳定销卡平台。</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="panel panel-bggray panel-feature">
				<div class="container">
					<div class="panel-heading">
						<h3 class="panel-title">为什么要选择{{$namePc}}？</h3>
						<div class="panel-subtitle">
							<p>安全快捷正规，卡券回收平台</p>
						</div>
					</div>
					<div class="panel-body">
						<ul class="feature-group clearfix">
							<li>
								<div class="feature-type">
									<i class="iconimg iconimg-type "></i>
									<h5>丰富</h5>
									<p>种类丰富多样</p>
								</div>
							</li>
							<li>
								<div class="feature-heart">
									<i class="iconimg iconimg-heart"></i>
									<h5>放心</h5>
									<p>客服一对一指导</p>
								</div>
							</li>
							<li>
								<div class="feature-safe">
									<i class="iconimg iconimg-safe"></i>
									<h5>保证</h5>
									<p>出色的专业服务团队</p>
								</div>
							</li>
							<li>
								<div class="feature-safe">
									<i class="iconimg iconimg-fast"></i>
									<h5>极速</h5>
									<p>快速核销极速返款</p>
								</div>
							</li>
							<li>
								<div class="feature-price">
									<i class="iconimg iconimg-price"></i>
									<h5>高价</h5>
									<p>价格实惠可商讨</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<problemCommon></problemCommon>
		</div>
	</div>
</template>

<script>
	// import { apiAddress } from '';// 导入我们的api接口
	import * as homeApi from '../../api/index.js'
	import hotCommon from '../common/hot_topick.vue'
	import problemCommon from '../common/problem/index.vue'
	import notic from '../common/noticle/index.vue'
	export default {
	  name: 'Home',
	  data () {
	    return {
	      msg: 'Welcome to Your Vue.js App',
				noticle:"",
				hotList:[],
        // currentScroll: 0,
        // testShow: false,
        // testShow2: false,
        // testShow3: false,
        // testShow4: false,
        // testShow5: false,
        swiper:[],
        noticleList:{}
	    }
	  },
		async created() {
      await this.$onLaunched
			this.getNotcile()
      this.getAllNotcile()
      this.carouselchart()
		},
    // mounted() {
    //   window.addEventListener('scroll', this.handleScrollbox, true)
    // },
		components:{
			problemCommon,
			hotCommon,
			notic
		},
		methods:{
      HTMLDecode(text) {
      	var temp = document.createElement("div");
      	temp.innerHTML = text;
      	var output = temp.innerText || temp.textContent;
      	temp = null;
      	return output;
      },
      getAllNotcile(){
      	let token = localStorage.getItem('token')
      	this.$api.noticepc({
      		token:token,
          page:1
      	}).then(res => {
          // console.log(res)
      		if(res.code === 1){
            if(res.data.data.length > 0){
              this.noticleList = res.data.data[0]
            }
      		}
      	})
      },
      carouselchart(){
        homeApi.carouselchart({

        })
        .then(result => {
          this.swiper = result.data
        })
      },
			getNotcile(){
				let token = localStorage.getItem('token')
				homeApi.getIndexNotice({
					token:token
				}).then(res => {
					if(res.code === 1){
						this.noticle = res.data.notice
					}
				})
			}
		}
	}
</script>

<style >
	.cover img{
		width: 120px;
	}
  .container-afwy{
    display: flex;
    height: 100%;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    min-width: 1200px;
    max-width: 1440px;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: center;
  }
  .conwds-img{


  }
  .home-banner-button{
    background: linear-gradient(to bottom, #359EFF  0, #359EFF  100%);
    background-size: auto 140%;
    color: #fff;
    border: 0;
    font-size: 16px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 800;
    padding: 0 30px;
    line-height: 58px;
    height: 58px;
    border-radius: 6px;
    display: block;
  }
  .home-banner-button:hover{
    color: #fff;
    background: #4fadff;
  }
  .masthead{
    margin-right: 106px;
    width: 600px;
    text-align: left;
  }
  .home-title{
    font-size: 48px;
    color: #111;
    font-weight: bold;
    text-align: left;
  }
  .home-des{
    color: #3f3f3f;
    margin-bottom: 16px;
    text-align: left;
  }
  .home-title + .home-title{
    margin-bottom: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue